export default {"src":"/_next/static/media/StarS white.c8f7b69b.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};